import {useContext} from "react";
import {AppContext} from "../../../App";

function Stepper({steps, currentStepId, setStep}) {
    const {isMobile} = useContext(AppContext);

    return (
        <ol className={"flex justify-self-center md:justify-center w-full text-sm font-medium text-center sm:text-base" + (currentStepId === 0 ? " hidden" : "")}>
            {steps.map((step, index) => {
                if (isMobile) {
                    return (
                        <li key={index}
                            className={"flex md:hidden items-center text-white " + (index < steps.length - 1 ? " w-full after:content-[''] after:w-full after:h-1 after:border-b after:border-4 after:inline-block" : "") + (index < currentStepId ? " after:border-primary-light" : "")}>
                        <span onClick={() => {
                            if (index < currentStepId) {
                                setStep(index)
                            }
                        }}
                              className={"flex items-center justify-center w-8 h-8 rounded-full shrink-0" + (index < currentStepId ? " bg-primary-light" : " bg-gray-300")}>
                            {index < currentStepId ?
                                <svg className="w-3 h-3" aria-hidden="true"
                                     xmlns="http://www.w3.org/2000/svg" fill="none"
                                     viewBox="0 0 16 12">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="M1 5.917 5.724 10.5 15 1.5"/>
                                </svg>
                                :
                                step.icon
                            }
                        </span>
                        </li>
                    );
                } else {
                    return (
                        <li key={index}
                            className={"hidden md:flex items-center justify-between" + (currentStepId >= index ? " font-bold text-primary-light" : " text-gray-500")}>
                            {index <= currentStepId ?
                                <span
                                    className="flex items-center">
                                <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 me-2.5" aria-hidden="true"
                                     xmlns="http://www.w3.org/2000/svg"
                                     fill="currentColor" viewBox="0 0 20 20">
                                    <path
                                        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                                </svg>
                        </span> :
                                <span className="me-2.5">{index + 1}</span>}
                            <span onClick={() => {
                                if (index < currentStepId) {
                                    setStep(index)
                                }
                            }}
                                  className={(index < currentStepId ? "cursor-pointer" : "")}>{step.title}</span>
                            {index < steps.length - 1 ?
                                <hr className={"w-20 h-px mx-4 bg-gray-300 border-0 rounded-xl"}/> : ""}
                        </li>
                    );
                }
            })}
        </ol>

    );
}

export default Stepper;